import React from "react";
import get from "lodash/get";
import set from "lodash/set";
import isEqual from "lodash/isEqual";
import {
  RaisedButton,
  TextField,
  Styles,
  Checkbox,
  RadioButtonGroup,
  RadioButton
} from "material-ui";
import { Navigation } from "react-router";
import Select from "react-select";
import juration from "juration";

import CurrencyField from "./currency-field.jsx";
import InjectedSelect from "./injected-select.jsx";
import DateTimeField from "./datetime-field.jsx";
import DurationField from "./duration-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../../stores/UserStore";

class PassRuleEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dirty: false,
      isSaving: false,
      showTimeRestrictionsEditor: false,
      showUseTimeRestrictionsEditor: false,
      showAdvanceEditor: false,
      ticketBucketsPhysicalVirtualState: "",
      values: {},
      isEditMode: false
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onShowTimeRestrictionsCheck =
      this.onShowTimeRestrictionsCheck.bind(this);
    this.onShowUseTimeRestrictionsCheck =
      this.onShowUseTimeRestrictionsCheck.bind(this);
    this.save = this.save.bind(this);
    this.delete = this.delete.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return {};
  }

  getStyles() {
    return {
      rule: {
        border: "1px solid #ccc",
        padding: 20,
        margin: "20px 0"
      },
      actions: {
        marginTop: 20
      },
      firstHeader: {
        margin: "0 0 10px"
      },
      header: {
        margin: "20px 0 10px"
      }
    };
  }

  onChange(id, e, checked) {
    this.onChangeValue(
      id,
      typeof checked !== "undefined"
        ? !get(this.state.values, id)
        : e.target.value
    );
  }

  onChangeValue(id, value) {
    let values = Object.assign({}, this.state.values);
    set(values, id, value);
    this.setState({
      dirty: true,
      values: values
    });
    if (this.props.onChange) {
      this.props.onChange(values);
    }
  }

  onShowTimeRestrictionsCheck(e, checked) {
    this.setState({ showTimeRestrictionsEditor: checked });
    if (!checked) {
      this.onChangeValue("restrictions.time.start_after", null);
      this.onChangeValue("restrictions.time.end_before", null);
      this.onChangeValue("restrictions.time.begin_within", null);
    }
  }

  onShowUseTimeRestrictionsCheck(e, checked) {
    this.setState({ showUseTimeRestrictionsEditor: checked });
    if (!checked) {
      this.onChangeValue("restrictions.use_time.use_after", null);
      this.onChangeValue("restrictions.use_time.use_before", null);
    }
  }

  save() {
    this.setState({ isSaving: true, isEditMode: false });
    this.props.save(this.state.values);
  }

  delete() {
    if (window.confirm("Are you sure?")) {
      this.props.save(null);
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var rule = newProps.rule;

    if (!this.state.dirty || this.state.isSaving) {
      this.setState({
        rule,
        dirty: false,
        isSaving: false,
        ticketBucketsPhysicalVirtualState:
          this.state.ticketBucketsPhysicalVirtualState ||
          (get(rule, "target.ticket_bucket") === "*"
            ? "*"
            : get(rule, "target.event.type")) ||
          "*",
        values: rule
          ? {
            name: rule.name || "",
            type: rule.type || "ticket",
            target: rule.target,
            global_target: rule.global_target,
            result: rule.result,
            restrictions: rule.restrictions
          }
          : {}
      });
    }
  }

  toggleEditMode() {
    this.setState(prev => ({ isEditMode: !prev.isEditMode }));
  }

  render() {
    const { mode, index } = this.props;
    const { type, name } = this.state.values;
    const isMembership = this.props.isMembership;
    const passOrMembership = isMembership ? 'membership' : 'pass';
    const passesOrMemberships = isMembership ? 'memberships' : 'passes';

    const applyToAllTicketBuckets =
      get(this.state.values, "target.ticket_bucket") === "*";
    const applyToAllPassBuckets =
      get(this.state.values, "target.pass_bucket") === "*";
    const applyToAllItemBuckets =
      get(this.state.values, "target.item_bucket") === "*";
    const styles = this.getStyles();

    let eventBucketIds = get(
      this.state.values,
      "global_target.event_bucket.id",
      [this.props.eventBucketId]
    );
    if (get(this.state.values, "global_target") === "*") {
      eventBucketIds = this.props.getEventBuckets().map(b => b.id);
    }

    let creditsEnabled = (
      this.props.getEventBucketById(this.props.eventBucketId) || {}
    ).credits_enabled;

    if (!this.state.isEditMode) {
      const credits = get(this.state.values, "result.credits", 0);
      const percentOff = get(this.state.values, "result.price.percent_off", 0);
      const dollarsOff = (
        get(this.state.values, "result.price.cents_off", 0) / 100
      ).toFixed(2);

      // const restrictions = [];
      const useRestrictions = [];
      const otherRestrictions = [];

      const totalUses = get(this.state.values, "restrictions.uses.total");
      const disallowConcurrent = get(
        this.state.values,
        "restrictions.uses.disallow_concurrent",
        false
      );
      const maxPerFilm = get(
        this.state.values,
        "restrictions.uses.max_per_film"
      );
      const maxPerEvent = get(
        this.state.values,
        "restrictions.uses.max_per_event"
      );
      const maxAdvanceReservations = get(
        this.state.values,
        "restrictions.uses.max_advance_reservations"
      );
      const isGlobal = get(this.state.values, "global_target", false);
      const globalTargets = get(
        this.state.values,
        "global_target.event_bucket.id",
        []
      );

      if (totalUses) {
        if (type === "pass") {
          useRestrictions.push(`Total of ${totalUses} target ${passesOrMemberships} per ${passOrMembership}`);
        } else if (type === "item") {
          useRestrictions.push(`Total of ${totalUses} items per ${passOrMembership}`);
        } else {
          useRestrictions.push(`Total of ${totalUses} tickets per ${passOrMembership}`);
        }
      }

      if (disallowConcurrent) {
        useRestrictions.push(
          "Disallow concurrent uses (i.e. multiple events at the same time)"
        );
      }

      if (get(this.state.values, "restrictions.uses.disallow_same", false)) {
        useRestrictions.push(`Only allow one ticket per event per ${passOrMembership}`);
      }

      if (maxPerFilm === 1) {
        useRestrictions.push(
          `Only allow one ticket per film per ${passOrMembership} (across physical and virtual events)`
        );
      }

      if (maxPerEvent) {
        useRestrictions.push(`${maxPerEvent} tickets per event per ${passOrMembership}`);
      }

      if (get(this.state.values, "restrictions.rush_line_only", false)) {
        otherRestrictions.push(
          "Only allow Rush Line ticket orders (no advance reservation)"
        );
      }

      if (get(this.state.values, "restrictions.box_office_only", false)) {
        otherRestrictions.push(
          "Only allow Box Office ticket orders (no online reservation)"
        );
      }

      // Date/time restrictions
      const startAfter = get(
        this.state.values,
        "restrictions.time.start_after"
      );
      const endBefore = get(this.state.values, "restrictions.time.end_before");
      const beginWithin = get(
        this.state.values,
        "restrictions.time.begin_within"
      );

      if (startAfter) {
        otherRestrictions.push(
          `Event must start after ${new Date(startAfter).toLocaleString()}`
        );
      }

      if (endBefore) {
        otherRestrictions.push(
          `Event must end before ${new Date(endBefore).toLocaleString()}`
        );
      }

      if (beginWithin) {
        const timeStr = juration.stringify(beginWithin / 1000);
        otherRestrictions.push(`Event must begin within ${timeStr}`);
      }

      // Use time restrictions
      const useAfter = get(
        this.state.values,
        "restrictions.use_time.use_after"
      );
      const useBefore = get(
        this.state.values,
        "restrictions.use_time.use_before"
      );

      if (useAfter) {
        otherRestrictions.push(
          `Can only be used after ${new Date(useAfter).toLocaleString()}`
        );
      }

      if (useBefore) {
        otherRestrictions.push(
          `Can only be used before ${new Date(useBefore).toLocaleString()}`
        );
      }

      if (maxAdvanceReservations) {
        otherRestrictions.push(
          `Restrict the number of advance reservations to ${maxAdvanceReservations}`
        );
      }

      if (
        get(
          this.state.values,
          "restrictions.bypass_geographic_restrictions",
          false
        )
      ) {
        otherRestrictions.push(
          "Bypasses geographic restrictions when unlocking virtual screenings"
        );
      }

      return (
        <div style={styles.rule}>
          <h2>{name || `${isMembership ? 'Membership' : 'Pass'} Rule ${index + 1}`}</h2>

          <div>
            <h3>Type</h3>
            <p>
              {type === "item"
                ? "Item orders (i.e. for buying items)"
                : type === "ticket"
                  ? "Ticket orders (i.e. for buying tickets)"
                  : type === "pass"
                    ? `Pass orders (i.e. for buying new ${passesOrMemberships})`
                    : type === "credit"
                      ? `Auto-issue credits on ${passOrMembership} purchase`
                      : "N/A"}
            </p>
          </div>

          {type !== "credit" ? (
            <div>
              <h3>Target</h3>
              {type === "ticket" ? (
                <div>
                  {applyToAllTicketBuckets ||
                    get(this.state.values, "target.event.type") ? (
                    <p>
                      Apply to all{" "}
                      {get(this.state.values, "target.event.type") ===
                        "physical"
                        ? "physical"
                        : get(this.state.values, "target.event.type") ===
                          "virtual"
                          ? "virtual"
                          : "physical & virtual"}{" "}
                      ticket buckets
                      {get(
                        this.state.values,
                        "target.exclude_ticket_bucket.id",
                        []
                      ).length > 0 &&
                        ` (excluding ${get(
                          this.state.values,
                          "target.exclude_ticket_bucket.id",
                          []
                        ).length
                        } ticket bucket${get(
                          this.state.values,
                          "target.exclude_ticket_bucket.id",
                          []
                        ).length > 1
                          ? "s"
                          : ""
                        })`}
                      {get(this.state.values, "target.exclude_tag.id", [])
                        .length > 0 &&
                        ` (excluding ${get(this.state.values, "target.exclude_tag.id", [])
                          .length
                        } tag${get(this.state.values, "target.exclude_tag.id", [])
                          .length > 1
                          ? "s"
                          : ""
                        })`}
                    </p>
                  ) : (
                    <ul
                      style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}
                    >
                      {get(this.state.values, "target.ticket_bucket.id", [])
                        .length > 0 && (
                          <li>
                            {
                              get(
                                this.state.values,
                                "target.ticket_bucket.id",
                                []
                              ).length
                            }{" "}
                            ticket bucket
                            {get(this.state.values, "target.ticket_bucket.id", [])
                              .length > 1
                              ? "s"
                              : ""}
                          </li>
                        )}
                      {get(this.state.values, "target.venue.id", []).length >
                        0 && (
                          <li>
                            {get(this.state.values, "target.venue.id", []).length}{" "}
                            venue
                            {get(this.state.values, "target.venue.id", [])
                              .length > 1
                              ? "s"
                              : ""}
                          </li>
                        )}
                      {get(this.state.values, "target.tag.id", []).length >
                        0 && (
                          <li>
                            {get(this.state.values, "target.tag.id", []).length}{" "}
                            tag
                            {get(this.state.values, "target.tag.id", []).length >
                              1
                              ? "s"
                              : ""}
                          </li>
                        )}
                    </ul>
                  )}
                </div>
              ) : type === "item" ? (
                <p>
                  {applyToAllItemBuckets
                    ? "Apply to all item buckets"
                    : `${get(this.state.values, "target.item_bucket.id", [])
                      .length
                    } item bucket${get(this.state.values, "target.item_bucket.id", [])
                      .length > 1
                      ? "s"
                      : ""
                    }`}
                </p>
              ) : (
                <p>
                  {applyToAllPassBuckets
                    ? `Apply to all ${passOrMembership} buckets`
                    : `${get(this.state.values, "target.pass_bucket.id", [])
                      .length
                    } pass bucket${get(this.state.values, "target.pass_bucket.id", [])
                      .length > 1
                      ? "s"
                      : ""
                    }`}
                </p>
              )}
            </div>
          ) : null}

          <div>
            <h3>Result</h3>
            {type === "credit" ? (
              <p>Issue {credits} credits</p>
            ) : (
              <ul
                style={{
                  listStyle: "none",
                  paddingLeft: 0
                }}
              >
                {percentOff && percentOff > 0 ? (
                  <li>{percentOff}% off</li>
                ) : null}
                {dollarsOff && dollarsOff > 0 ? (
                  <li>${dollarsOff} off</li>
                ) : null}
              </ul>
            )}
          </div>

          {useRestrictions.length > 0 ? (
            <div style={{ marginTop: 16 }}>
              <h3
                style={{
                  margin: "0 0 8px",
                  fontSize: "14px",
                  fontWeight: "bold"
                }}
              >
                Use restrictions
              </h3>
              <ul style={{ paddingLeft: 20, margin: 0 }}>
                {useRestrictions.map((restriction, index) => (
                  <li key={index} style={{ fontSize: "13px", marginBottom: 4 }}>
                    {restriction}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          {otherRestrictions.length > 0 ? (
            <div style={{ marginTop: 16 }}>
              <h3
                style={{
                  margin: "0 0 8px",
                  fontSize: "14px",
                  fontWeight: "bold"
                }}
              >
                Other restrictions
              </h3>
              <ul style={{ paddingLeft: 20, margin: 0 }}>
                {otherRestrictions.map((restriction, index) => (
                  <li key={index} style={{ fontSize: "13px", marginBottom: 4 }}>
                    {restriction}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          {isGlobal && (
            <div style={{ marginTop: 16 }}>
              <h3>Global rule</h3>

              <p>
                {isGlobal === "*"
                  ? "Applies to all event buckets"
                  : `Applies to ${globalTargets.length} event bucket${globalTargets.length > 1 ? "s" : ""
                  }`}
              </p>
            </div>
          )}

          <RaisedButton
            label="Edit"
            onClick={this.toggleEditMode}
            style={{ marginTop: 16 }}
          />
          {mode === "pass_bucket" &&
            UserStore.hasPermission("edit_pass_bucket") && [
              <RaisedButton
                label="▲"
                key="shiftUp-view"
                style={{ minWidth: 30, marginLeft: 7 }}
                disabled={!this.props.canShiftUp}
                onTouchTap={() => this.props.shiftPosition(-1)}
              />,
              <RaisedButton
                label="▼"
                key="shiftDown-view"
                style={{ minWidth: 30, marginLeft: 7 }}
                disabled={!this.props.canShiftDown}
                onTouchTap={() => this.props.shiftPosition(1)}
              />
            ]}
        </div>
      );
    }

    return (
      <div style={styles.rule}>
        <div>
          <TextField
            value={get(this.state.values, "name", "")}
            floatingLabelText="Rule name (optional)"
            floatingLabelFixed={true}
            onChange={e => this.onChangeValue("name", e.target.value)}
            style={{ width: "100%", marginBottom: 20 }}
            disabled={!UserStore.hasPermission("edit_pass_bucket")}
          />
          {mode === "pass_bucket" ? (
            <div>
              <h3 style={styles.firstHeader}>Type</h3>
              <RadioButtonGroup
                name="mailing_type"
                valueSelected={this.state.values.type}
                onChange={(e, v) => {
                  if (v === "ticket") {
                    this.onChangeValue("target.pass_bucket", undefined);
                  }
                  this.onChangeValue("type", v);
                }}
              >
                {[
                  <RadioButton
                    value="ticket"
                    label="Ticket orders (i.e. for buying tickets)"
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />,
                  <RadioButton
                    value="item"
                    label="Item orders (i.e. for buying items)"
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />,
                  <RadioButton
                    value="pass"
                    label={`Pass orders (i.e. for buying new ${isMembership ? "memberships" : "passes"})`}
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />,
                  creditsEnabled ? (
                    <RadioButton
                      value="credit"
                      label={`Auto-issue credits on ${isMembership ? "membership" : "pass"} purchase`}
                      disabled={!UserStore.hasPermission("edit_pass_bucket")}
                    />
                  ) : null
                ].filter(b => !!b)}
              </RadioButtonGroup>
            </div>
          ) : null}
          {type === "credit" ? (
            <div>
              <h3
                style={Object.assign(
                  {},
                  mode === "pass_bucket" ? styles.header : styles.firstHeader,
                  { marginBottom: -10 }
                )}
              >
                Result
              </h3>
              <TextField
                value={get(this.state.values, "result.credits", "")}
                floatingLabelText="# of credits to auto-issue"
                floatingLabelFixed={true}
                hintText="0"
                onChange={e =>
                  this.onChangeValue("result.credits", e.target.value)
                }
                style={{ width: 200 }}
              />
            </div>
          ) : (
            <div>
              <h3
                style={
                  mode === "pass_bucket" ? styles.header : styles.firstHeader
                }
              >
                Target
              </h3>
              {mode === "pass_bucket" && type === "ticket" ? (
                <div>
                  <Checkbox
                    checked={
                      applyToAllTicketBuckets ||
                      get(this.state.values, "target.event.type")
                    }
                    inputStyle={{ width: 100 }}
                    label={
                      <span>
                        Apply to all{" "}
                        <span
                          style={{
                            display: "inline-block",
                            width: 150,
                            margin: "-20px 10px",
                            verticalAlign: 7
                          }}
                        >
                          <Select
                            clearable={false}
                            disabled={
                              !(
                                applyToAllTicketBuckets ||
                                get(this.state.values, "target.event.type")
                              )
                            }
                            value={this.state.ticketBucketsPhysicalVirtualState}
                            options={[
                              { label: "Physical & Virtual", value: "*" },
                              { label: "Physical", value: "physical" },
                              { label: "Virtual", value: "virtual" }
                            ]}
                            onChange={e => {
                              this.setState({
                                ticketBucketsPhysicalVirtualState: e.value
                              });
                              if (
                                applyToAllTicketBuckets ||
                                get(this.state.values, "target.event.type")
                              ) {
                                if (e.value === "*") {
                                  this.onChangeValue("target.event", undefined);
                                  this.onChangeValue(
                                    "target.ticket_bucket",
                                    "*"
                                  );
                                } else {
                                  this.onChangeValue(
                                    "target.ticket_bucket",
                                    undefined
                                  );
                                  this.onChangeValue(
                                    "target.event.type",
                                    e.value
                                  );
                                }
                              }
                            }}
                          />
                        </span>
                        ticket buckets
                      </span>
                    }
                    onCheck={e => {
                      const checked = !(
                        applyToAllTicketBuckets ||
                        get(this.state.values, "target.event.type")
                      );

                      if (checked) {
                        if (
                          this.state.ticketBucketsPhysicalVirtualState === "*"
                        ) {
                          this.onChangeValue("target.event", undefined);
                          this.onChangeValue("target.ticket_bucket", "*");
                        } else {
                          this.onChangeValue("target.ticket_bucket", undefined);
                          this.onChangeValue("target.event", {
                            type: this.state.ticketBucketsPhysicalVirtualState
                          });
                        }
                      } else {
                        this.onChangeValue("target.ticket_bucket", undefined);
                        this.onChangeValue("target.event", undefined);
                      }
                    }}
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />
                  {!applyToAllTicketBuckets &&
                    !get(this.state.values, "target.event.type") ? (
                    <div>
                      <InjectedSelect
                        key="ticket_buckets_apply"
                        style={{ marginBottom: 10 }}
                        value={get(
                          this.state.values,
                          "target.ticket_bucket.id",
                          []
                        )}
                        types={["ticket_buckets"]}
                        multi={true}
                        label="Ticket buckets"
                        labelFormatter={b =>
                          `${b.event.name} – ${b.name}` +
                          (get(this.state.values, "global_target")
                            ? ` (${this.props.getEventBucketById(
                              b.event.event_bucket
                            ) &&
                            this.props.getEventBucketById(
                              b.event.event_bucket
                            ).name
                            })`
                            : "")
                        }
                        eventBucketId={eventBucketIds}
                        onChange={selected =>
                          this.onChangeValue(
                            "target.ticket_bucket.id",
                            selected
                          )
                        }
                        disabled={!UserStore.hasPermission("edit_pass_bucket")}
                      />
                      <InjectedSelect
                        key="venues_apply"
                        value={get(this.state.values, "target.venue.id", [])}
                        types={["venues"]}
                        multi={true}
                        label="Venues"
                        labelFormatter={v =>
                          v.name +
                          (get(this.state.values, "global_target")
                            ? ` (${this.props.getEventBucketById(v.event_bucket) &&
                            this.props.getEventBucketById(v.event_bucket)
                              .name
                            })`
                            : "")
                        }
                        eventBucketId={eventBucketIds}
                        onChange={selected =>
                          this.onChangeValue("target.venue.id", selected)
                        }
                        disabled={!UserStore.hasPermission("edit_pass_bucket")}
                      />
                      <InjectedSelect
                        key="tags_apply"
                        value={get(this.state.values, "target.tag.id", [])}
                        types={["tags"]}
                        multi={true}
                        label="Tags"
                        labelFormatter={t =>
                          t.name +
                          (get(this.state.values, "global_target")
                            ? ` (${this.props.getEventBucketById(t.event_bucket) &&
                            this.props.getEventBucketById(t.event_bucket)
                              .name
                            })`
                            : "")
                        }
                        eventBucketId={eventBucketIds}
                        onChange={selected =>
                          this.onChangeValue("target.tag.id", selected)
                        }
                        disabled={!UserStore.hasPermission("edit_pass_bucket")}
                      />
                    </div>
                  ) : (
                    <div>
                      <InjectedSelect
                        key="ticket_buckets_exclude"
                        value={get(
                          this.state.values,
                          "target.exclude_ticket_bucket.id",
                          []
                        )}
                        types={["ticket_buckets"]}
                        multi={true}
                        label="Ticket buckets to exclude"
                        placeholder="None excluded"
                        labelFormatter={b =>
                          `${b.event.name} – ${b.name}` +
                          (get(this.state.values, "global_target")
                            ? ` (${this.props.getEventBucketById(
                              b.event.event_bucket
                            ) &&
                            this.props.getEventBucketById(
                              b.event.event_bucket
                            ).name
                            })`
                            : "")
                        }
                        eventBucketId={eventBucketIds}
                        onChange={selected =>
                          this.onChangeValue(
                            "target.exclude_ticket_bucket.id",
                            selected
                          )
                        }
                        disabled={!UserStore.hasPermission("edit_pass_bucket")}
                      />
                      <InjectedSelect
                        key="tags_exclude"
                        value={get(
                          this.state.values,
                          "target.exclude_tag.id",
                          []
                        )}
                        types={["tags"]}
                        multi={true}
                        label="Tags to exclude"
                        labelFormatter={t =>
                          t.name +
                          (get(this.state.values, "global_target")
                            ? ` (${this.props.getEventBucketById(t.event_bucket) &&
                            this.props.getEventBucketById(t.event_bucket)
                              .name
                            })`
                            : "")
                        }
                        eventBucketId={eventBucketIds}
                        onChange={selected =>
                          this.onChangeValue("target.exclude_tag.id", selected)
                        }
                        disabled={!UserStore.hasPermission("edit_pass_bucket")}
                      />
                    </div>
                  )}
                </div>
              ) : mode === "pass_bucket" && type === "item" ? (
                <div>
                  <Checkbox
                    checked={applyToAllItemBuckets}
                    label="Apply to all item buckets"
                    onCheck={(e, checked) =>
                      this.onChangeValue(
                        "target.item_bucket",
                        checked ? "*" : {}
                      )
                    }
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />
                  {!applyToAllItemBuckets ? (
                    <InjectedSelect
                      key="item_bucket_apply"
                      value={get(
                        this.state.values,
                        "target.item_bucket.id",
                        []
                      )}
                      types={["item_buckets"]}
                      multi={true}
                      label="Item buckets"
                      labelFormatter={b => b.name}
                      eventBucketId={eventBucketIds}
                      onChange={selected =>
                        this.onChangeValue("target.item_bucket.id", selected)
                      }
                      disabled={!UserStore.hasPermission("edit_pass_bucket")}
                    />
                  ) : null}
                </div>
              ) : (
                <div>
                  <Checkbox
                    checked={applyToAllPassBuckets}
                    label={`Apply to all ${isMembership ? "memberships" : "pass buckets"}`}
                    onCheck={(e, checked) =>
                      this.onChangeValue(
                        "target.pass_bucket",
                        checked ? "*" : {}
                      )
                    }
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />
                  {!applyToAllPassBuckets ? (
                    <InjectedSelect
                      key="pass_bucket_apply"
                      value={get(
                        this.state.values,
                        "target.pass_bucket.id",
                        []
                      )}
                      types={["pass_buckets"]}
                      multi={true}
                      label={`${isMembership ? 'Membership' : 'Pass'} buckets`}
                      labelFormatter={b => b.name}
                      eventBucketId={eventBucketIds}
                      onChange={selected =>
                        this.onChangeValue("target.pass_bucket.id", selected)
                      }
                      disabled={!UserStore.hasPermission("edit_pass_bucket")}
                    />
                  ) : null}
                </div>
              )}

              <h3
                style={Object.assign({}, styles.header, { marginBottom: -10 })}
              >
                Result
              </h3>
              <TextField
                value={get(this.state.values, "result.price.percent_off", "")}
                floatingLabelText="Percent off (0 - 100)"
                onChange={e =>
                  this.onChangeValue("result.price.percent_off", e.target.value)
                }
                floatingLabelFixed={true}
                hintText="0"
                type="number"
                style={{ width: 200 }}
                disabled={!UserStore.hasPermission("edit_pass_bucket")}
              />
              <CurrencyField
                value={get(this.state.values, "result.price.cents_off", "")}
                floatingLabelText="Dollars off"
                floatingLabelFixed={true}
                hintText="$0.00"
                onChange={e =>
                  this.onChangeValue("result.price.cents_off", e.target.value)
                }
                style={{ marginLeft: 7, width: 200 }}
                disabled={!UserStore.hasPermission("edit_pass_bucket")}
              />
              <h3 style={styles.header}>Use restrictions</h3>
              {type === "pass" ? (
                <div style={{ marginTop: -20 }}>
                  <TextField
                    value={get(
                      this.state.values,
                      "restrictions.uses.total",
                      ""
                    )}
                    floatingLabelText={`Number of target ${passesOrMemberships} per ${passOrMembership}`}
                    floatingLabelFixed={true}
                    hintText="Unlimited"
                    onChange={e =>
                      this.onChangeValue(
                        "restrictions.uses.total",
                        e.target.value
                      )
                    }
                    type="number"
                    style={{ width: 275 }}
                  />
                </div>
              ) : type === "item" ? (
                <div style={{ marginTop: -20 }}>
                  <TextField
                    value={get(
                      this.state.values,
                      "restrictions.uses.total",
                      ""
                    )}
                    floatingLabelText={`Number of target items per ${passOrMembership}`}
                    floatingLabelFixed={true}
                    hintText="Unlimited"
                    onChange={e =>
                      this.onChangeValue(
                        "restrictions.uses.total",
                        e.target.value
                      )
                    }
                    type="number"
                    style={{ width: 275 }}
                  />
                </div>
              ) : (
                <div>
                  <Checkbox
                    checked={get(
                      this.state.values,
                      "restrictions.uses.disallow_concurrent",
                      false
                    )}
                    label="Disallow concurrent uses (i.e. multiple events at the same time)"
                    onCheck={this.onChange.bind(
                      null,
                      "restrictions.uses.disallow_concurrent"
                    )}
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />
                  <Checkbox
                    checked={get(
                      this.state.values,
                      "restrictions.uses.disallow_same",
                      false
                    )}
                    label={`Only allow one ticket per event per ${isMembership ? "membership" : "pass"}`}
                    onCheck={this.onChange.bind(
                      null,
                      "restrictions.uses.disallow_same"
                    )}
                    disabled={!UserStore.hasPermission("edit_pass_bucket")}
                  />
                  {mode === "pass_bucket" ? (
                    <Checkbox
                      checked={
                        get(
                          this.state.values,
                          "restrictions.uses.max_per_film"
                        ) === 1
                      }
                      label={`Only allow one ticket per film per ${isMembership ? "membership" : "pass"} (across physical and virtual events)`}
                      onCheck={() =>
                        this.onChangeValue(
                          "restrictions.uses.max_per_film",
                          this.state.values.restrictions.uses.max_per_film === 1
                            ? undefined
                            : 1
                        )
                      }
                      disabled={!UserStore.hasPermission("edit_pass_bucket")}
                    />
                  ) : null}
                  {mode === "pass_bucket" ? (
                    <TextField
                      value={get(
                        this.state.values,
                        "restrictions.uses.total",
                        ""
                      )}
                      floatingLabelText={`Total number of tickets per ${isMembership ? "membership" : "pass"}`}
                      floatingLabelFixed={true}
                      hintText="Unlimited"
                      onChange={e =>
                        this.onChangeValue(
                          "restrictions.uses.total",
                          e.target.value
                        )
                      }
                      type="number"
                      style={{ width: 250 }}
                      disabled={!UserStore.hasPermission("edit_pass_bucket")}
                    />
                  ) : null}
                  {!get(
                    this.state.values,
                    "restrictions.uses.disallow_same",
                    false
                  ) ? (
                    <TextField
                      value={get(
                        this.state.values,
                        "restrictions.uses.max_per_event",
                        ""
                      )}
                      floatingLabelText={`Number of tickets per event per ${isMembership ? "membership" : "pass"}`}
                      floatingLabelFixed={true}
                      hintText="Unlimited"
                      onChange={e =>
                        this.onChangeValue(
                          "restrictions.uses.max_per_event",
                          e.target.value
                        )
                      }
                      type="number"
                      style={{ width: 300, marginLeft: 10 }}
                    />
                  ) : null}
                </div>
              )}
              {mode === "pass_bucket"
                ? (() => {
                  let showTimeRestrictions =
                    this.state.showTimeRestrictionsEditor ||
                    !!get(
                      this.state.values,
                      "restrictions.time.start_after"
                    ) ||
                    !!get(
                      this.state.values,
                      "restrictions.time.end_before"
                    ) ||
                    !!get(
                      this.state.values,
                      "restrictions.time.begin_within"
                    );

                  let showUseTimeRestrictions =
                    this.state.showUseTimeRestrictionsEditor ||
                    !!get(
                      this.state.values,
                      "restrictions.use_time.use_after"
                    ) ||
                    !!get(
                      this.state.values,
                      "restrictions.use_time.use_before"
                    );

                  let showAdvanceEditor = !!(
                    this.state.showAdvanceEditor ||
                    get(
                      this.state.values,
                      "restrictions.uses.max_advance_reservations"
                    )
                  );

                  return (
                    <div>
                      {type !== "pass" ? (
                        <div>
                          <h3 style={styles.header}>Other restrictions</h3>
                          {type !== "item" ? (
                            <div>
                              <Checkbox
                                checked={get(
                                  this.state.values,
                                  "restrictions.rush_line_only",
                                  false
                                )}
                                label="Only allow Rush Line ticket orders (no advance reservation)"
                                onCheck={this.onChange.bind(
                                  null,
                                  "restrictions.rush_line_only"
                                )}
                                disabled={
                                  !UserStore.hasPermission("edit_pass_bucket")
                                }
                              />
                              <Checkbox
                                checked={get(
                                  this.state.values,
                                  "restrictions.box_office_only",
                                  false
                                )}
                                label="Only allow Box Office ticket orders (no online reservation)"
                                onCheck={this.onChange.bind(
                                  null,
                                  "restrictions.box_office_only"
                                )}
                                disabled={
                                  !UserStore.hasPermission("edit_pass_bucket")
                                }
                              />
                            </div>
                          ) : null}

                          {type !== "item" ? (
                            <div>
                              <Checkbox
                                checked={showTimeRestrictions}
                                label="Restrict based on the date / time of the event"
                                onCheck={this.onShowTimeRestrictionsCheck}
                                disabled={
                                  !UserStore.hasPermission("edit_pass_bucket")
                                }
                              />
                              {showTimeRestrictions ? (
                                <div style={{ marginBottom: "1em" }}>
                                  <DateTimeField
                                    style={{
                                      display: "inline-block",
                                      marginRight: 24
                                    }}
                                    label="Event must start after"
                                    placeholder="Any time"
                                    value={get(
                                      this.state.values,
                                      "restrictions.time.start_after"
                                    )}
                                    onChange={(_, date) =>
                                      this.onChangeValue(
                                        "restrictions.time.start_after",
                                        date
                                      )
                                    }
                                  />
                                  <DateTimeField
                                    style={{ display: "inline-block" }}
                                    label="Event must end before"
                                    placeholder="Any time"
                                    value={get(
                                      this.state.values,
                                      "restrictions.time.end_before"
                                    )}
                                    onChange={(_, date) =>
                                      this.onChangeValue(
                                        "restrictions.time.end_before",
                                        date
                                      )
                                    }
                                  />
                                  <DurationField
                                    value={get(
                                      this.state.values,
                                      "restrictions.time.begin_within",
                                      0
                                    )}
                                    floatingLabelText={
                                      "Event must begin within"
                                    }
                                    floatingLabelFixed={true}
                                    style={{
                                      marginLeft: 24,
                                      verticalAlign: -2
                                    }}
                                    onChange={e =>
                                      this.onChangeValue(
                                        "restrictions.time.begin_within",
                                        e.target.value
                                      )
                                    }
                                    placeholder="No restriction"
                                  />
                                </div>
                              ) : null}
                            </div>
                          ) : null}

                          <Checkbox
                            checked={showUseTimeRestrictions}
                            label={`Restrict based on the current time (when the ${isMembership ? "membership" : "pass"} is used to place an order)`}
                            onCheck={this.onShowUseTimeRestrictionsCheck}
                            disabled={
                              !UserStore.hasPermission("edit_pass_bucket")
                            }
                          />
                          {showUseTimeRestrictions ? (
                            <div style={{ marginBottom: "1em" }}>
                              <DateTimeField
                                style={{
                                  display: "inline-block",
                                  marginRight: 24
                                }}
                                label="Current time must be after"
                                placeholder="Any time"
                                value={get(
                                  this.state.values,
                                  "restrictions.use_time.use_after"
                                )}
                                onChange={(_, date) =>
                                  this.onChangeValue(
                                    "restrictions.use_time.use_after",
                                    date
                                  )
                                }
                              />
                              <DateTimeField
                                style={{ display: "inline-block" }}
                                label="Current time must be before"
                                placeholder="Any time"
                                value={get(
                                  this.state.values,
                                  "restrictions.use_time.use_before"
                                )}
                                onChange={(_, date) =>
                                  this.onChangeValue(
                                    "restrictions.use_time.use_before",
                                    date
                                  )
                                }
                              />
                            </div>
                          ) : null}

                          {type !== "item" ? (
                            <Checkbox
                              checked={showAdvanceEditor}
                              label="Restrict the number of advance reservations (i.e. number of tickets for which event end time has not passed)"
                              onCheck={() => {
                                if (showAdvanceEditor) {
                                  this.setState(
                                    { showAdvanceEditor: false },
                                    () => {
                                      this.onChangeValue(
                                        "restrictions.uses.max_advance_reservations",
                                        undefined
                                      );
                                    }
                                  );
                                } else {
                                  this.setState({ showAdvanceEditor: true });
                                }
                              }}
                              disabled={
                                !UserStore.hasPermission("edit_pass_bucket")
                              }
                            />
                          ) : null}
                          {showAdvanceEditor ? (
                            <TextField
                              value={get(
                                this.state.values,
                                "restrictions.uses.max_advance_reservations",
                                ""
                              )}
                              floatingLabelText="Total number of advance reservations"
                              floatingLabelFixed={true}
                              hintText="0"
                              onChange={e =>
                                this.onChangeValue(
                                  "restrictions.uses.max_advance_reservations",
                                  e.target.value
                                )
                              }
                              type="number"
                              style={{ width: 300, marginBottom: "1em" }}
                            />
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  );
                })()
                : null}
            </div>
          )}
          {(mode === "pass_bucket" ||
            (this.props.parent && this.props.parent.is_virtual)) &&
            type !== "item" ? (
            <div>
              <h3 style={styles.header}>
                Virtual screening restrictions {type}
              </h3>
              <Checkbox
                checked={get(
                  this.state.values,
                  "restrictions.bypass_geographic_restrictions",
                  false
                )}
                style={{ marginBottom: mode === "pass_bucket" ? 0 : 25 }}
                label={
                  <div style={{ maxWidth: 450 }}>
                    <div>{`Bypass geographic restrictions when unlocking ${mode === "pass_bucket"
                        ? "virtual screenings"
                        : "this screening"
                      }`}</div>
                    <div
                      style={{
                        fontSize: "0.9em",
                        color: "rgba(0,0,0,0.6)",
                        lineHeight: "1.2"
                      }}
                    >
                      By enabling this option, targeted {isMembership ? "members" : "passholders"} will be able
                      to unlock{" "}
                      {mode === "pass_bucket"
                        ? "the targeted virtual screenings"
                        : "the screening"}{" "}
                      even if they are not within the set geographic
                      restrictions.
                    </div>
                  </div>
                }
                onCheck={this.onChange.bind(
                  null,
                  "restrictions.bypass_geographic_restrictions"
                )}
                disabled={!UserStore.hasPermission("edit_pass_bucket")}
              />
            </div>
          ) : null}
          {mode === "pass_bucket" ? (
            <div>
              <h3 style={styles.header}>Global rule</h3>
              <Checkbox
                checked={!!get(this.state.values, "global_target", false)}
                label={`Make this ${isMembership ? "membership" : "pass"} rule global (apply to other event buckets)`}
                onCheck={(e, checked) =>
                  this.onChangeValue(
                    "global_target",
                    !this.state.values.global_target ? "*" : undefined
                  )
                }
                disabled={!UserStore.hasPermission("edit_pass_bucket")}
              />
              {get(this.state.values, "global_target") ? (
                <InjectedSelect
                  style={{ marginBottom: 10 }}
                  value={get(
                    this.state.values,
                    "global_target.event_bucket.id",
                    []
                  )}
                  types={["event_buckets"]}
                  multi={true}
                  eventBucketId={this.props.eventBucketId}
                  label="Target event buckets"
                  labelFormatter={b => `${b.name}`}
                  onChange={selected => {
                    if (selected.length === 0) {
                      this.onChangeValue("global_target", "*");
                    } else {
                      this.onChangeValue(
                        "global_target.event_bucket.id",
                        selected
                      );
                    }
                  }}
                  placeholderText="Default: apply to all event buckets"
                />
              ) : null}
            </div>
          ) : null}
        </div>
        {UserStore.hasPermission("edit_pass_bucket") ? (
          <div style={styles.actions}>
            <RaisedButton
              label="Close"
              onClick={this.toggleEditMode}
              style={{ marginRight: 7 }}
            />
            {mode === "pass_bucket" ? (
              [
                <RaisedButton
                  label={this.state.dirty ? "Save" : "No changes to save"}
                  key="save"
                  primary={true}
                  disabled={!this.state.dirty}
                  onClick={this.save}
                />,
                <RaisedButton
                  label="Delete"
                  key="delete"
                  onClick={this.delete}
                  style={{ marginLeft: 7 }}
                />,
                <RaisedButton
                  label="▲"
                  key="shiftUp-edit"
                  style={{ minWidth: 30, marginLeft: 7 }}
                  disabled={!this.props.canShiftUp}
                  onTouchTap={() => this.props.shiftPosition(-1)}
                />,
                <RaisedButton
                  label="▼"
                  key="shiftDown-edit"
                  style={{ minWidth: 30, marginLeft: 7 }}
                  disabled={!this.props.canShiftDown}
                  onTouchTap={() => this.props.shiftPosition(1)}
                />
              ]
            ) : (
              <RaisedButton label="Remove" onClick={this.delete} style={{}} />
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(PassRuleEditor);



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-rule-editor.jsx